import { useEffect, useState } from 'react';
import { Company } from '../../model/user/Company';
import { ClientService } from '../../app/brand/client/service';

interface IClientSuppliersFilterParams {
    displayName?: string;
    page: number;
    perPage: number;
}

export function useClientSuppliers() {
    const [filterParams, setFilterParams] = useState<IClientSuppliersFilterParams>({
        displayName: '',
        page: 1,
        perPage: 12,
    });
    const [suppliers, setSuppliers] = useState<Company[]>([]);
    const [count, setCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        ClientService.getClientsOrSuppliers({
            type: 'supplier',
            onlyWithActive: true,
            ...filterParams,
        }).then(response => {
            setSuppliers(response.data);
            setCount(response.count);
            setTotalPages(Math.ceil(response.count / filterParams.perPage));
        });
    }, [JSON.stringify(filterParams)]);

    return { suppliers, totalPages, filterParams, count, setFilterParams };
}
